<ng-container *ngIf="activityExist">
    <div class="status-row" [class.ready]="projectActivity.ready"
         [style.padding-left.rem]="nestingLevel * 1.55"
         [style.--nesting-level]="nestingLevel"
         [style.--show-guide]="shouldShowGuide ? 'block' : 'none'">
    <div class="date-n-icon">
      <div class="click-block">
        <div class="status-icon" *ngIf="projectActivity.startDate" (click)="toggleReady()">
          <mat-icon class="status-icn">done</mat-icon>
        </div>
      </div>

      <div class="status-date-and-ready" (click)="editProjectActivity()">
        <div class="status-title">{{projectActivity.type.title}}</div>

        <i class="pi pi-paperclip" style="font-size: 100%" *ngIf="projectActivity.files?.length > 3"></i>
        <ng-container *ngIf="projectActivity.files?.length <= 3">
          <i class="pi pi-paperclip" style="font-size: 100%" *ngFor="let file of projectActivity.files"
             (click)="openFile($event, file)"></i>
        </ng-container>

        <i class="pi pi-exclamation-triangle" style="font-size: 120%" *ngIf="projectActivity.overlaps"
           pTooltip="Overlap with activity" tooltipPosition="bottom"></i>

        <div class="order-status-title" *ngIf="projectActivity.workOrderTask" (click)="editTask($event)">
          <div class="order-status-div">SO-{{projectActivity.workOrderTask?.number}}</div>
        </div>

        <div class="visual-guide"></div>

          <div class="right-block">
              <div class="workload-aware-icon" *ngIf="projectActivity.workloadAware" pTooltip="Workload calculations (BETA) were applied" tooltipPosition="bottom">
                  <mat-icon class="status-icn">error</mat-icon>
              </div>
            <div class="status-date delivery-instructions" *ngIf="projectActivity.deliveryInstructions"
                 pTooltip="{{projectActivity.deliveryInstructions}}" tooltipPosition="bottom">
              <i class="pi pi-exclamation-triangle" style="font-size: 100%"></i>
            </div>
            <div class="status-date user-tooltip" *ngFor="let user of visibleUsers"
                 pTooltip="{{user.name}}" tooltipPosition="bottom">
                <span class="span-date">{{ user.shortCode }}</span>
            </div>
            <div class="status-date user-tooltip" *ngIf="assignedUsers.length > 5"
                 pTooltip="{{hiddenUsersTooltip}}" tooltipPosition="bottom">
                <span class="span-date">+{{ assignedUsers.length - 4 }}</span>
            </div>
            <div class="status-date start-date" *ngIf="projectActivity.startDate">
              <span class="span-date">{{ projectActivity.startDate | date:'MMM d, y' }}</span>
            </div>
            <div class="status-date duration" *ngIf="hours">
              <span class="span-date">{{ hours }}</span>
            </div>
            <div class="status-date end-date" *ngIf="projectActivity.endDate">
              <span class="span-date">{{ projectActivity.endDate | date:'MMM d, y' }}</span>
            </div>
            <div class="manual-control-block">
              <div class="manual-control" *ngIf="projectActivity.manualControl" pTooltip="Manual Control"
                   tooltipPosition="bottom">M
              </div>
            </div>
            <div class="status-date" *ngIf="!projectActivity.startDate"><span class="span-date">No Date</span></div>
          </div>
      </div>
    </div>
  </div>
</ng-container>
